import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useResourceAvailablePrice } from "./hooks";

export const QuestionResourceAvailablePrice = () => {
	const { resourceAvailablePrice, onSetResourceAvailablePriceAmount } = useResourceAvailablePrice();

	const title = "利用可能な最低価格";
	const guide =
		"このキャンペーンを利用することができる価格の最低価格を設定できます。<br />割引適用前の合計料金が、ここで設定した金額以上の場合 予約可能になります。";

	return (
		<QuestionForMain
			required={true}
			title={title}
			guide={guide}
			inputChildren={
				<QuestionSectionWrapper>
					<p>最低価格：</p>

					<InputNumberField
						value={resourceAvailablePrice.amount?.value}
						handleInput={onSetResourceAvailablePriceAmount}
						errorMessage={resourceAvailablePrice.amount?.error}
					/>
					<p>円（税込）以上の予約で利用可能</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionResourceAvailablePrice.displayName = "QuestionResourceAvailablePrice";
